<template>

  <div :class="`c-article`">
    <article class="c-article__item" :class="`c-article__item--${item.type}`" v-for="(item, index) in items" :key="index" :id="slugify(item)">
      <Title v-if="item.type === 'title'" :content="item" />
      <Highlight v-if="item.type === 'highlight'" :content="item" />
      <HighlightWithText v-if="item.type === 'highlightWithText'" :content="item" />
      <Slider v-if="item.type === 'slider'" :content="item" />
      <TextImage v-if="item.type === 'textImage'" :content="item" />
      <TextContent v-if="item.type === 'text'" :content="item" />
      <Form v-if="item.type === 'form'" :content="item" />
      <Logos v-if="item.type === 'logos'" :content="item" />
      <Button v-if="item.type === 'button'" class="u-align-center" :content="item.button" />
    </article>
  </div>

</template>

<script>
import Title from '@/components/content/Title'
import Highlight from '@/components/content/Highlight'
import HighlightWithText from '@/components/content/HighlightWithText'
import Slider from '@/components/content/Slider'
import TextImage from '@/components/content/TextImage'
import TextContent from '@/components/content/TextContent'
import Form from '@/components/content/Form'
import Logos from '@/components/content/Logos'
import Button from '@/components/Button'

export default {
  name: 'ContentBlocks',
  props: ['items'],

  methods: {
    slugify (item) {
      if (item.title) {
        let newText = item.title.toLowerCase()
        newText = newText.replace(' ', '-')
        this.$emit('slugUpdated')
        return newText
      }
    }
  },

  components: {
    Title,
    Highlight,
    HighlightWithText,
    Slider,
    TextImage,
    TextContent,
    Form,
    Logos,
    Button
  }
}
</script>
